// extracted by mini-css-extract-plugin
var _1 = "EmailCopyToEntityPrivateConfirmationModal-modulecheckbox__qj8CN";
var _2 = "EmailCopyToEntityPrivateConfirmationModal-moduledescription__Cupcd ConfirmationModal-moduledescription__bs9Tm";
export { _1 as "checkbox", _2 as "description" }
